import { OwnAdministrativeFeeDto } from "./ownadministrativefeedto";
import { VatPatternDto } from "./vatPattern/vatpatterndto";

export class OwnAdministrativeFeeDetailDto {
    idOwnAdministrativeFeeDetail?: number;
    startDate?: string;
    endDate?: string;
    optionalFeeIndicator?: string;
    firstPaymentIndicator?: boolean;
    ageControlIndicator?: string;
    ageLimit?: number;
    price?: number;
    ownAdministrativeFeeDto?: OwnAdministrativeFeeDto;
    vatPatternDto?: VatPatternDto;

    constructor(init?: Partial<OwnAdministrativeFeeDetailDto>) {
        Object.assign(this, init);
    }
}